import { render, staticRenderFns } from "./MoreTableActions.vue?vue&type=template&id=63970268&scoped=true&"
import script from "./MoreTableActions.vue?vue&type=script&lang=js&"
export * from "./MoreTableActions.vue?vue&type=script&lang=js&"
import style0 from "./MoreTableActions.vue?vue&type=style&index=0&id=63970268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63970268",
  null
  
)

export default component.exports